var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 464,
    viewBox: "0 0 500 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.954 171.37C433.717 144.056 386.593 97.4705 347.071 38.1094L346.545 37.8001C307.023 51.4726 259.899 43.5846 211.662 15.1569L209.808 14.0742L212.404 104.276C221.551 244.094 269.2 304.94 345.866 434.922L347.72 436.005C424.385 394.647 472.035 388.862 481.181 259.623L483.777 172.422L481.923 171.37H481.954Z",
    fill: "#D1E8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.177 157.296C449.94 129.982 402.816 83.3963 363.294 24.0352L362.768 23.7259C323.246 37.3984 276.122 29.5104 227.885 1.08267L226.031 0L210.334 14.384L211.662 15.1573C259.899 43.5851 307.023 51.504 346.545 37.8005L347.071 38.1099C386.593 97.4709 433.717 144.057 481.954 171.371L483.808 172.422L481.212 259.623C475.248 343.979 452.876 375.716 416.722 399.133C461.868 372.437 490.699 340.39 497.404 245.58L500 158.379L498.146 157.327L498.177 157.296Z",
    fill: "#E4EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 158.347L498.146 157.296C449.909 129.982 402.785 83.396 363.263 24.0349L362.738 23.7256L346.515 37.8003L347.04 38.1096C386.562 97.4706 433.686 144.056 481.923 171.37L483.777 172.422L500 158.347Z",
    fill: "#E4EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.808 172.423L481.212 259.624C475.248 343.979 452.876 375.717 416.722 399.133C461.868 372.438 490.699 340.391 497.404 245.58L500 158.379L483.777 172.454L483.808 172.423Z",
    fill: "#B6D7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.948 174.866C429.793 148.17 383.689 102.606 345.062 44.5748L344.537 44.2654C305.911 57.6596 259.806 49.9262 212.651 22.1172L210.859 21.0654L195.501 35.1092L196.799 35.8825C243.954 63.6916 290.058 71.4249 328.685 58.0308L329.21 58.3401C367.836 116.371 413.941 161.936 461.096 188.631L462.888 189.652L460.354 274.904C454.514 357.373 432.636 388.43 397.316 411.289C441.473 385.182 469.655 353.846 476.206 261.139L478.74 175.887L476.948 174.866Z",
    fill: "#5B81F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.74 175.887L476.948 174.866C429.793 148.171 383.688 102.606 345.062 44.575L344.537 44.2656L328.685 58.031L329.21 58.3403C367.836 116.371 413.941 161.936 461.096 188.632L462.888 189.652L478.74 175.887Z",
    fill: "#5B81F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.888 189.652L460.354 274.904C454.514 357.373 432.636 388.43 397.316 411.289C441.473 385.182 469.655 353.846 476.206 261.139L478.74 175.887L462.888 189.652Z",
    fill: "#5B81F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.145 199.365C402.909 172.051 355.785 125.466 316.262 66.1045L315.737 65.7952C276.215 79.4677 229.091 71.5797 180.854 43.152L179 42.0693L181.596 132.271C190.742 272.09 238.392 332.935 315.057 462.917L316.911 464C393.577 422.642 441.226 416.858 450.373 287.618L452.969 200.417L451.115 199.365H451.145Z",
    fill: "#D1E8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.145 199.365C402.909 172.051 355.785 125.466 316.262 66.1045L315.737 65.7952C276.215 79.4677 229.091 71.5797 180.854 43.152L179 42.0693L181.596 132.271C190.742 272.09 238.392 332.935 315.057 462.917L316.911 464C393.577 422.642 441.226 416.858 450.373 287.618L452.969 200.417L451.115 199.365H451.145Z",
    fill: "#D1E8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.369 185.321C419.132 158.007 372.008 111.422 332.485 52.0606L331.96 51.7513C292.438 65.4238 245.314 57.5358 197.077 29.1081L195.223 28.0254L179.525 42.3785L180.854 43.1518C229.091 71.5795 276.215 79.4985 315.737 65.795L316.262 66.1043C355.785 125.465 402.909 172.051 451.145 199.365L453 200.417L450.404 287.618C444.44 371.973 422.068 403.742 385.913 427.127C431.06 400.432 459.89 368.385 466.596 273.574L469.192 186.373L467.338 185.321H467.369Z",
    fill: "#E4EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.192 186.343L467.338 185.291C419.101 157.977 371.977 111.391 332.455 52.03L331.929 51.7207L315.706 65.7954L316.232 66.1047C355.754 125.466 402.878 172.051 451.115 199.365L452.969 200.417L469.192 186.343Z",
    fill: "#E4EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 200.417L450.404 287.618C444.44 371.973 422.068 403.742 385.913 427.127C431.06 400.432 459.89 368.385 466.596 273.574L469.192 186.373L452.969 200.448L453 200.417Z",
    fill: "#B6D7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.467 403.742C246.951 304.91 217.008 255.2 209.777 146.717L208.14 89.7686C246.364 107.06 282.982 112.566 315.984 106.009C348.987 150.738 385.604 187.549 423.829 214.43L422.191 269.46C414.96 369.591 385.048 384.718 325.502 414.754C322.381 416.332 319.229 417.94 315.984 419.58C312.74 414.197 309.557 408.908 306.436 403.742H306.467Z",
    fill: "#5B81F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.773 402.103C250.258 303.271 220.315 253.561 213.084 145.078L211.539 91.2846C210.395 90.7897 209.283 90.3257 208.14 89.7998L209.777 146.748C217.008 255.231 246.92 304.941 306.467 403.773C309.588 408.939 312.771 414.229 316.015 419.611C317.128 419.054 318.209 418.497 319.322 417.941C316.077 412.558 312.894 407.269 309.804 402.103H309.773Z",
    fill: "#5B80F6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.109 239.36C159.362 218.03 135.634 207.97 116.108 216.891C100.831 223.872 95.8261 239.545 92.0563 254.615C91.6288 256.326 90.551 257.799 89.049 258.725C87.9547 259.4 86.6887 259.75 85.4029 259.731L75.8479 259.593C75.1348 259.583 74.4334 259.786 73.8375 260.179L71.8568 261.479C70.8517 262.14 70.2476 263.26 70.2476 264.462V266.898C70.2476 268.101 69.6418 269.224 68.635 269.884L64.5449 272.563C63.7906 273.058 63.2509 273.819 63.0347 274.695L60.6859 284.244C60.2073 286.191 58.2167 287.362 56.2822 286.835L52.0123 285.67C50.4574 285.246 48.8118 285.916 47.9965 287.306L47.0458 288.925C46.3063 290.184 44.8753 290.866 43.431 290.646L41.1599 290.3C39.5721 290.059 38.0172 290.907 37.3636 292.374L36.6275 294.027C35.9128 295.629 34.1417 296.474 32.4466 296.022L30.5782 295.524C28.8517 295.063 27.0493 295.95 26.3627 297.6L25.8791 298.762C25.209 300.373 23.4726 301.261 21.7742 300.865L20.5693 300.584C18.8609 300.185 17.1147 301.088 16.4528 302.713L15.4063 305.28C15.1373 305.942 14.6751 306.506 14.0809 306.903L11.6282 308.537C10.6197 309.208 9.34056 309.324 8.22974 308.842L6.47025 308.079C4.54901 307.248 2.32736 308.24 1.66549 310.225L0.305437 314.305C-0.562753 316.908 0.510107 319.036 2.38018 321.52L6.04936 325.94C8.59451 328.036 11.9138 326.896 14.8881 325.475C14.8881 325.475 97.9966 285.78 98.066 285.747C103.8 283.009 108.621 286.873 113.294 289.78C118.114 292.777 123.191 295.444 128.796 296.598C136.38 298.16 144.349 297.357 151.404 294.134C170.93 285.213 178.857 260.689 169.111 239.357L169.109 239.36Z",
    fill: "url(#paint0_linear_2425_43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.366 244.336C163.619 223.006 139.891 212.946 120.365 221.867C105.087 228.847 100.083 244.521 96.3131 259.59C95.8856 261.3 94.8078 262.774 93.3058 263.7C92.2114 264.375 90.9455 264.725 89.6597 264.707L80.1047 264.568C79.3916 264.559 78.6901 264.762 78.0943 265.154L76.1136 266.455C75.1084 267.115 74.5043 268.236 74.5043 269.438V271.874C74.5043 273.077 73.8986 274.199 72.8918 274.86L68.8017 277.538C68.0474 278.034 67.5077 278.795 67.2914 279.671L64.9427 289.219C64.464 291.167 62.4735 292.337 60.539 291.811L56.2691 290.645C54.7142 290.221 53.0686 290.891 52.2533 292.281L51.3025 293.9C50.5631 295.16 49.1321 295.841 47.6878 295.622L45.415 295.275C43.8272 295.034 42.2724 295.883 41.6188 297.35L40.8826 299.002C40.1679 300.605 38.3969 301.45 36.7018 300.998L34.8333 300.499C33.1069 300.039 31.3045 300.925 30.6178 302.576L30.1342 303.738C29.4641 305.349 27.7277 306.237 26.0293 305.84L24.8244 305.56C23.1161 305.16 21.3698 306.063 20.7079 307.689L19.6615 310.256C19.3924 310.918 18.9303 311.482 18.3361 311.878L15.8834 313.512C14.8749 314.184 13.5957 314.3 12.4849 313.818L10.7254 313.055C8.80414 312.223 6.5825 313.215 5.92063 315.201L4.56057 319.281C3.69238 321.884 4.51766 324.751 6.63531 326.495L10.0949 329.344C12.64 331.441 16.1672 331.871 19.1432 330.45C19.1432 330.45 102.252 290.756 102.321 290.723C108.055 287.985 112.876 291.849 117.549 294.755C122.369 297.753 127.446 300.42 133.051 301.574C140.635 303.135 148.604 302.333 155.659 299.11C175.185 290.188 183.112 265.664 173.366 244.333V244.336Z",
    fill: "url(#paint1_linear_2425_43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.667 297.102C126.769 297.102 113.728 288.213 107.443 274.455C103.277 265.338 102.602 255.31 105.54 246.219C108.425 237.295 114.466 230.346 122.55 226.652C126.583 224.81 130.89 223.874 135.355 223.874C149.253 223.874 162.294 232.764 168.579 246.521C172.745 255.639 173.42 265.666 170.482 274.757C167.597 283.682 161.556 290.631 153.472 294.325C149.438 296.168 145.13 297.102 140.667 297.102Z",
    fill: "url(#paint2_linear_2425_43)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.385 274.42C134.157 274.42 127.343 269.731 124.027 262.475C121.819 257.642 121.454 252.347 123.001 247.564C124.481 242.985 127.556 239.43 131.661 237.555C133.701 236.622 135.882 236.15 138.141 236.15C145.369 236.15 152.183 240.84 155.499 248.095C157.707 252.928 158.072 258.223 156.525 263.007C155.045 267.585 151.97 271.14 147.865 273.015C145.825 273.948 143.644 274.42 141.385 274.42Z",
    fill: "url(#paint3_linear_2425_43)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.489 274.946C136.261 274.946 129.448 270.257 126.132 263.001C123.923 258.169 123.559 252.874 125.105 248.09C126.586 243.512 129.661 239.956 133.766 238.081C135.806 237.149 137.986 236.677 140.246 236.677C147.474 236.677 154.287 241.366 157.603 248.622C159.811 253.455 160.176 258.75 158.63 263.533C157.149 268.112 154.074 271.667 149.969 273.542C147.929 274.474 145.749 274.946 143.489 274.946Z",
    fill: "url(#paint4_linear_2425_43)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.531 261.184C153.478 261.348 153.421 261.516 153.363 261.673C152.273 264.624 150.217 266.913 147.507 268.15C146.085 268.797 144.57 269.128 142.997 269.128C139.861 269.128 136.841 267.861 134.447 265.682C133 264.367 131.79 262.719 130.917 260.815C129.38 257.452 129.128 253.765 130.201 250.439C130.701 248.888 131.468 247.503 132.452 246.346C133.488 245.119 134.761 244.141 136.23 243.474C137.651 242.827 139.166 242.495 140.739 242.495C144.876 242.495 148.815 244.7 151.362 248.294C151.915 249.068 152.404 249.909 152.815 250.809C154.351 254.171 154.609 257.86 153.531 261.184Z",
    fill: "url(#paint5_linear_2425_43)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.106 265.189C167.33 257.378 141.789 262.086 133.467 280.245C128.746 290.548 130.456 302.453 136.956 312.728L136.946 312.723L139.567 317.29C142.393 322.212 142.448 328.253 139.711 333.226L111.749 384.023C111.401 384.656 111.242 385.375 111.293 386.095L111.766 392.893C111.883 394.575 110.864 396.128 109.276 396.691L104.916 398.24C103.419 398.771 102.417 400.189 102.417 401.777V406.303C102.417 407.725 101.613 409.024 100.342 409.66L97.5708 411.045C96.1232 411.767 95.3029 413.339 95.534 414.94L96.1133 418.947C96.2305 419.763 96.077 420.593 95.676 421.313L92.7215 426.611C92.3105 427.349 92.1603 428.204 92.294 429.037L93.6144 437.227C93.8488 438.678 93.2133 440.134 91.9903 440.949L87.7649 443.767C86.6507 444.509 86.0169 445.79 86.1011 447.127L86.725 456.994C87.0205 461.659 98.8203 463.719 98.8203 463.719L104.067 456.143C105.177 455.382 105.794 454.088 105.687 452.747L105.205 446.725C105.089 445.284 105.812 443.904 107.063 443.177L112.65 439.937C113.2 439.619 113.659 439.167 113.986 438.622L117.501 432.762C117.868 432.152 118.399 431.658 119.036 431.34L122.458 429.621C123.947 428.874 124.765 427.233 124.467 425.594L123.826 422.083C123.542 420.522 124.27 418.951 125.645 418.158L129.324 416.037C130.699 415.245 131.427 413.674 131.143 412.112L130.354 407.781C130.055 406.137 130.879 404.492 132.376 403.747L138.146 400.875C138.868 400.517 139.454 399.936 139.818 399.218L166.663 346.548C169.076 341.812 173.651 338.556 178.915 337.826L187.676 336.611L187.66 336.603C200.156 335.055 210.759 328.505 215.62 317.897C223.942 299.736 214.811 272.978 191.103 265.189H191.106Z",
    fill: "url(#paint6_linear_2425_43)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.29 267.264C173.603 256.867 148.466 263.161 140.142 281.322C135.421 291.624 137.131 303.53 143.631 313.804L143.621 313.8L146.242 318.367C149.068 323.289 149.122 329.33 146.386 334.303L118.424 385.1C118.076 385.732 117.917 386.452 117.968 387.171L118.44 393.97C118.558 395.652 117.539 397.205 115.951 397.768L111.591 399.316C110.094 399.848 109.092 401.266 109.092 402.853V407.379C109.092 408.802 108.288 410.101 107.017 410.736L104.246 412.121C102.798 412.844 101.978 414.415 102.209 416.017L102.788 420.024C102.905 420.839 102.752 421.67 102.351 422.389L99.3963 427.688C98.9853 428.425 98.8351 429.28 98.9688 430.114L100.289 438.304C100.524 439.755 99.8882 441.211 98.6651 442.026L94.4397 444.843C93.3256 445.586 92.6918 446.867 92.7759 448.204L93.3998 458.071C93.6953 462.735 98.9606 465.3 102.815 462.656L110.742 457.219C111.851 456.458 112.469 455.164 112.361 453.824L111.879 447.801C111.764 446.36 112.487 444.98 113.738 444.254L119.325 441.014C119.875 440.696 120.334 440.243 120.66 439.699L124.176 433.839C124.542 433.228 125.074 432.735 125.711 432.416L129.133 430.698C130.621 429.95 131.44 428.31 131.141 426.671L130.501 423.16C130.217 421.599 130.945 420.027 132.32 419.235L135.999 417.114C137.374 416.322 138.102 414.751 137.818 413.189L137.029 408.858C136.73 407.214 137.554 405.57 139.051 404.824L144.821 401.952C145.542 401.594 146.128 401.013 146.493 400.295L173.338 347.624C175.751 342.889 180.326 339.632 185.59 338.903L194.351 337.688L194.334 337.68C206.831 336.131 217.434 329.582 222.295 318.974C230.617 300.813 218.972 277.662 196.285 267.266L196.29 267.264Z",
    fill: "url(#paint7_linear_2425_43)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.513 332.78C181.792 332.78 174.818 331.212 168.343 328.244C158.453 323.712 150.596 316.423 146.219 307.721C142.04 299.411 141.579 290.813 144.927 283.513C149.449 273.643 160.562 267.511 173.929 267.511C180.65 267.511 187.625 269.079 194.1 272.046C214.113 281.219 224.619 301.286 217.518 316.78C212.994 326.65 201.882 332.78 188.516 332.78H188.513Z",
    fill: "url(#paint8_linear_2425_43)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.597 407.177L270.93 404.675C270.733 404.381 270.656 404.025 270.71 403.676L271.354 399.603C271.489 398.749 270.829 397.979 269.966 397.979H268.756C267.86 397.979 267.191 397.15 267.383 396.274L267.688 394.872C267.781 394.448 267.672 394.006 267.394 393.674L265.902 391.883C265.574 391.49 265.059 391.305 264.555 391.403L261.253 392.042C260.668 392.154 260.078 391.888 259.775 391.376L258.521 389.252C258.285 388.854 258.262 388.366 258.457 387.947L260.919 382.633C261.134 382.171 261.081 381.628 260.781 381.216L259.09 378.892C258.821 378.522 258.401 378.263 257.943 378.269C256.984 378.283 256.296 377.357 256.582 376.444L256.625 376.308C256.757 375.888 256.682 375.43 256.426 375.072L255.066 373.169C254.664 372.606 253.913 372.42 253.294 372.728L253.018 372.867C252.315 373.219 251.462 372.927 251.122 372.218L250.189 370.276C249.937 369.749 250.036 369.12 250.438 368.698L252.312 366.73C252.749 366.27 252.825 365.575 252.495 365.032L249.351 359.854C249.029 359.323 249.093 358.643 249.509 358.182L250.584 356.994C250.981 356.555 251.061 355.914 250.783 355.391L238.09 331.465C236.143 327.794 235.819 323.814 237.15 319.878L237.168 319.82C238.211 317.468 238.998 314.992 239.523 312.435L239.535 312.401L239.53 312.404C241.534 302.598 239.68 291.622 233.528 282.06C221.809 263.845 200.318 253.866 184.013 264.723C164.563 277.676 162.155 302.22 173.873 320.436C180.344 330.494 190.211 336.874 200.524 338.791L200.512 338.8L202.656 339.397C206.918 340.303 210.581 343.005 212.707 346.808L224.077 367.155C224.642 368.165 225.616 368.881 226.748 369.119L228.771 369.545C229.899 369.782 230.869 370.492 231.435 371.495L257.595 417.891C258.457 419.418 259.983 420.452 261.721 420.687L264.851 421.108C266.161 421.284 267.484 420.875 268.469 419.994C270.616 418.074 272.531 416.219 273.652 415.162L272.802 408.248C272.879 407.879 272.805 407.494 272.595 407.18L272.597 407.177Z",
    fill: "url(#paint9_linear_2425_43)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M276.755 402.985L274.965 411.519L274.554 413.491C274.196 415.201 272.571 416.348 270.841 416.117L270.304 416.043L265.674 415.422C263.938 415.191 262.406 414.155 261.55 412.628L235.385 366.232C234.822 365.227 233.849 364.518 232.723 364.28L230.703 363.854C229.565 363.618 228.593 362.902 228.03 361.891L216.66 341.545C214.534 337.741 210.873 335.042 206.611 334.133L204.464 333.538L204.474 333.528C194.161 331.607 184.296 325.231 177.824 315.171C166.107 296.955 169.957 273.6 186.432 263.004C202.906 252.407 225.761 258.579 237.478 276.794C243.628 286.359 245.482 297.335 243.476 307.143L243.481 307.138L243.471 307.174C242.945 309.731 242.161 312.203 241.119 314.555L241.098 314.613C239.767 318.555 240.093 322.531 242.04 326.203L254.731 350.126C255.01 350.648 254.931 351.29 254.537 351.731L253.459 352.914C253.043 353.378 252.98 354.056 253.3 354.588L256.441 359.771C256.773 360.312 256.699 361.007 256.263 361.464L254.39 363.431C253.985 363.857 253.885 364.484 254.137 365.009L255.068 366.955C255.41 367.66 256.263 367.956 256.968 367.602L257.242 367.465C257.862 367.155 258.615 367.338 259.015 367.903L260.371 369.808C260.629 370.166 260.703 370.623 260.571 371.044L260.528 371.181C260.244 372.085 260.923 373.006 261.87 373.006C262.317 373.006 262.743 373.218 263.007 373.586L264.727 375.948C265.027 376.364 265.08 376.905 264.864 377.369L262.401 382.683C262.207 383.099 262.233 383.588 262.469 383.989L263.722 386.115C264.027 386.625 264.616 386.894 265.201 386.779L268.505 386.141C269.005 386.041 269.525 386.226 269.852 386.62L271.341 388.409C271.62 388.741 271.73 389.183 271.635 389.609L271.329 391.009C271.139 391.887 271.808 392.714 272.703 392.714H273.912C274.776 392.714 275.438 393.488 275.302 394.34L274.66 398.417C274.607 398.763 274.682 399.121 274.881 399.41L276.548 401.914C276.753 402.229 276.827 402.614 276.753 402.982L276.755 402.985Z",
    fill: "url(#paint10_linear_2425_43)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.025 328.886C199.846 328.886 188.818 322.54 182.247 312.326C172.118 296.58 175.272 276.438 189.279 267.428C193.697 264.586 198.883 263.082 204.274 263.082C215.453 263.082 226.481 269.428 233.051 279.642C243.181 295.388 240.027 315.53 226.02 324.54C221.601 327.383 216.415 328.886 211.023 328.886H211.025Z",
    fill: "url(#paint11_linear_2425_43)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.203 300.606C197.842 300.606 192.553 297.562 189.403 292.665C184.545 285.114 186.057 275.455 192.775 271.134C194.894 269.77 197.38 269.051 199.966 269.051C205.327 269.051 210.615 272.094 213.766 276.992C218.624 284.543 217.112 294.202 210.394 298.523C208.275 299.886 205.788 300.606 203.203 300.606Z",
    fill: "url(#paint12_linear_2425_43)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M204.338 299.694C198.977 299.694 193.689 296.65 190.538 291.753C185.68 284.202 187.192 274.543 193.91 270.222C196.029 268.858 198.515 268.139 201.102 268.139C206.463 268.139 211.751 271.182 214.902 276.079C219.759 283.631 218.248 293.29 211.53 297.611C209.41 298.974 206.923 299.694 204.338 299.694Z",
    fill: "url(#paint13_linear_2425_43)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.155 291.265C210.523 292.101 209.751 292.833 208.834 293.422C207.361 294.369 205.636 294.869 203.842 294.869C202.442 294.869 201.059 294.569 199.748 294.011H199.743C197.576 293.095 195.633 291.476 194.267 289.355C191.278 284.713 191.763 278.922 195.151 275.581C195.589 275.15 196.077 274.756 196.609 274.412C198.076 273.465 199.803 272.965 201.597 272.965C202.638 272.965 203.675 273.128 204.675 273.443C207.258 274.249 209.6 276.032 211.178 278.479C213.884 282.693 213.74 287.85 211.157 291.265H211.155Z",
    fill: "#729EB1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M274.965 411.518L274.554 413.491C274.196 415.201 272.571 416.348 270.841 416.117L270.304 416.043L227.643 343.519C226.791 342.07 227.265 340.206 228.705 339.34C230.163 338.465 232.054 338.944 232.919 340.406L274.967 411.517L274.965 411.518Z",
    fill: "url(#paint14_linear_2425_43)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_43",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 191,
    width: 132,
    height: 104
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.363 261.673C152.848 260.726 152.41 259.742 152.064 258.722C150.927 255.396 150.733 251.872 151.364 248.294C148.817 244.7 144.877 242.495 140.741 242.495C139.168 242.495 137.653 242.827 136.232 243.474C134.764 244.142 133.49 245.121 132.454 246.346C131.549 252.638 132.1 258.895 134.147 264.862C134.241 265.136 134.342 265.415 134.447 265.682C135.421 268.328 136.662 270.838 138.168 273.191C142.466 268.486 148.281 265.34 154.505 263.53C154.089 262.931 153.704 262.308 153.363 261.673ZM260.944 221.386C256.403 208.149 245.196 198.325 229.39 193.726C214.768 189.47 197.701 190.217 181.326 195.831C167.899 200.434 156.103 207.916 147.375 217.267C153.057 219.876 158.271 223.823 162.528 228.905C168.868 222.596 177.476 217.177 187.473 213.746C194.876 211.211 202.379 209.927 209.513 209.927C214.621 209.927 219.542 210.583 224.097 211.91C233.82 214.741 240.54 220.287 243.022 227.531C248.484 243.453 232.267 264.046 207.618 272.501C206.639 272.837 205.656 273.153 204.672 273.443C201.488 274.385 198.306 275.1 195.148 275.579C191.76 278.92 191.276 284.713 194.263 289.353C195.632 291.474 197.573 293.093 199.74 294.009H199.745C203.549 293.357 207.369 292.441 211.152 291.262C212.025 290.993 212.893 290.714 213.761 290.416C230.13 284.802 244.067 274.92 253.002 262.587C262.656 249.254 265.476 234.622 260.941 221.385L260.944 221.386Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.067 291.931C253.37 275.905 273.973 240.483 262.085 212.813C250.197 185.144 210.321 175.706 173.018 191.732C135.716 207.759 115.113 243.181 127 270.85C138.888 298.52 178.764 307.958 216.067 291.931Z",
    fill: "url(#paint15_radial_2425_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.557 304.033C202.116 304.033 214.729 291.42 214.729 275.861C214.729 260.302 202.116 247.689 186.557 247.689C170.998 247.689 158.385 260.302 158.385 275.861C158.385 291.42 170.998 304.033 186.557 304.033Z",
    fill: "url(#paint16_radial_2425_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.056 263.723C233.508 253.217 247.692 231.576 240.736 215.387C233.78 199.197 208.319 194.589 183.867 205.094C159.415 215.6 145.231 237.241 152.187 253.43C159.142 269.62 184.604 274.228 209.056 263.723Z",
    fill: "url(#paint17_radial_2425_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.505 287.661C165.633 287.661 174.655 278.64 174.655 267.511C174.655 256.383 165.633 247.361 154.505 247.361C143.376 247.361 134.355 256.383 134.355 267.511C134.355 278.64 143.376 287.661 154.505 287.661Z",
    fill: "url(#paint18_radial_2425_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.816 262.932C191.317 248.432 191.317 224.922 176.816 210.421C162.316 195.921 138.806 195.921 124.306 210.421C109.805 224.922 109.805 248.432 124.306 262.932C138.806 277.433 162.316 277.433 176.816 262.932Z",
    fill: "url(#paint19_radial_2425_43)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 191L236 189.5C232.014 203.67 232.361 212.175 236 228L218 211L214.5 191Z",
    fill: "#5B81F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189 193.5L214.5 192L218.5 214L192.5 212.5L189 193.5Z",
    fill: "#D1E8F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2425_43",
    x1: 162.449,
    y1: 232.735,
    x2: 22.3717,
    y2: 344.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F2C849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F3D765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F4E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F4DE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F3D866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F3CF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F2C340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F2C747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3CD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F4E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F4DE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F3D866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F3CF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F2C442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F3D25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F4E178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F4DC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F2C747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4DD6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3D561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F2CB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3D664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F4E075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4D867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F2C646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3D15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F4E077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F4DA6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2C442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F2CA4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3D45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F5E37B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2425_43",
    x1: 3.47946,
    y1: 300.171,
    x2: 179.677,
    y2: 248.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EBAF28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E49E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E19307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E09003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2425_43",
    x1: 161.46,
    y1: 286.739,
    x2: 114.768,
    y2: 234.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFAB26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DD8F16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C46700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2425_43",
    x1: 141.315,
    y1: 237.047,
    x2: 138.379,
    y2: 271.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFAB26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F0B52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F6D246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F5D044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3C93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EFBD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E9AD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2970A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2425_43",
    x1: 126.19,
    y1: 264.051,
    x2: 157.758,
    y2: 247.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EBAF28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E49E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E19307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E09003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2425_43",
    x1: 143.428,
    y1: 268.653,
    x2: 140.564,
    y2: 245.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFAB26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DD8F16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C46700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2425_43",
    x1: 189.14,
    y1: 267.608,
    x2: 98.6915,
    y2: 462.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#AE93F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CDAEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DCBCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BDA0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#A88EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D6B7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DEBEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B397F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#BFA2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DCBCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEA1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A88EF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B99DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D5B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#DFBFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C7AAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A78CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B397F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C8AAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E8C7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DBBCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C2A5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B195F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A68CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B99DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#D3B4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E2C2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#C8AAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B79BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A48AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A389F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2425_43",
    x1: 80.1575,
    y1: 463.174,
    x2: 238.114,
    y2: 208.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#9F7DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9B70F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9568E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#895ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#754EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6945A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2425_43",
    x1: 220.208,
    y1: 337.105,
    x2: 118.896,
    y2: 241.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#7F56C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6945A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2425_43",
    x1: 181.571,
    y1: 263.414,
    x2: 273.77,
    y2: 421.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D3E9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E1F3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ECFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BBCFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B0C4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C5D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D3E4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DCEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DFEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D6E8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BFD9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CEE0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DAE7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E1EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E3ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DFE9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D5E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C4D3D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ACC0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A6BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2425_43",
    x1: 200.389,
    y1: 355.933,
    x2: 264.113,
    y2: 319.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A7BCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A6BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2425_43",
    x1: 267.475,
    y1: 321.868,
    x2: 176.329,
    y2: 282.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C0D3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A4C0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2425_43",
    x1: 193.326,
    y1: 270.563,
    x2: 209.477,
    y2: 298.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D3E9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E1F3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ECFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2425_43",
    x1: 191.055,
    y1: 291.319,
    x2: 236.05,
    y2: 262.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B9D4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9ABDC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#84ABBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#76A1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2425_43",
    x1: 254.655,
    y1: 375.267,
    x2: 246.616,
    y2: 380.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D5E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7DBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B0CAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#90B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2425_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.531 241.824) rotate(-23.25) scale(73.7338 54.7737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DFEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ECFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#BED8D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2425_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.557 275.861) scale(28.1716 28.1716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC0C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2425_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.185 234.123) rotate(-23.25) scale(48.1735 31.8339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC0C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2425_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.209 267.998) scale(20.0354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC0C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2425_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.561 236.676) scale(37.1308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8FAFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A3BBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC0C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 464,
    fill: "white",
    transform: "translate(179)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image3.622a69f27f10ffc982dfd673fe80dee0.svg";
export { ForwardRef as ReactComponent };